import React from 'react';
import PropTypes from 'prop-types';

const Tag = ({ 
  children, 
  variant = 'primary', 
  size = 'medium',
  className = '',
  ...props 
}) => {
  const baseClasses = 'w-fit font-medium rounded-full';

  const variants = {
    primary: 'bg-[#2a62aa] text-white',
    secondary: 'bg-[#f7fbff] text-[#2a62aa]',
    outline: 'bg-transparent border border-[#2a62aa] text-[#2a62aa]',
  };

  const sizes = {
    small: 'px-2 py-1 text-xs',
    medium: 'px-3 py-1 text-sm',
    large: 'px-4 py-2 text-base',
  };

  const tagClasses = `${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`;

  return (
    <div className={tagClasses} {...props}>
      {children}
    </div>
  );
};

Tag.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'outline']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
};

export default Tag;
